export class Tooltip extends DrupalBehavior {

  onContent(context) {

    // mobile
    const mobile = () => {
      $('.tooltip-wrap span', context).on('click', (e) => {
        $(e.target).siblings('.tooltip').fadeToggle();
      })
    }

    const smMax = window.matchMedia('(max-width: 990px)');

    if (smMax.matches) {
      mobile();
    }

    smMax.addListener((e) => {
      if (e.matches) {
        mobile();
      }
    })

    // desktop
    const desktop = () => {
      var tooltipWrap = $('.tooltip-wrap span', context);
      var offset;
  
      tooltipWrap.mouseenter(function() {
        offset = $(window).width() - ($(this).offset().left + $(this).width());
        if (offset < 330) {
          $(this).siblings('.tooltip').addClass('bottom');
        }
        if (offset > 330) {
          $(this).siblings('.tooltip').removeClass('bottom');
        }
        $(this).siblings('.tooltip').fadeIn('fast');
      });
      tooltipWrap.mouseleave(function() {
        offset = $(window).width() - ($(this).offset().left + $(this).width());
        if (offset > 330) {
          $(this).siblings('.tooltip').removeClass('bottom');
        }
        $(this).siblings('.tooltip').fadeOut('fast')
      });
    }

    const mdMin = window.matchMedia('(min-width: 991px)');

    mdMin.addListener((e) => {
      if (e.matches) {
        desktop();
      }
    })

    if (mdMin.matches) {
      desktop();
    }
  }

}

DrupalBehavior.register('guthrie_theme', 'tooltip', Tooltip);
